import { Column, Row } from 'types/table';

export const filterEmptyTableColumns = (columns: Column[], rows: Row[]): [Column[], Row[]] => {
  const emptyColumns = columns.map((_, i) => rows.every(row => !row[i].value));
  const filteredColumns: Column[] = columns.filter((_, i) => !emptyColumns[i]);
  const filteredRows: Row[] = rows.map(row => row.filter((_, i) => !emptyColumns[i]));
  return [filteredColumns, filteredRows];
};
